import { colors } from '../../style';

export const variants = {
  default: {
    background: colors.white,
    borderColor: colors.gray400,
  },
  gray100: {
    background: colors.gray100,
    borderColor: colors.gray400,
  },
};
